import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/Zoap/ProductShowcase";
import Footer from "../../components/Footer";
import Cta from "../../components/Cta";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet";

const Zoap = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
       <Helmet>
        <title>Zoap Strain - Creamy & Citrusy Hybrid | BeyondBloom™</title>
        <meta
          name="description"
          content="Zoap is a premium cannabis strain featuring a complex aroma with creamy, citrusy notes. Perfect for a balanced and enjoyable experience."
        />
        <meta
          name="keywords"
          content="Zoap strain, hybrid cannabis, citrus aroma, creamy weed, premium cultivars, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Zoap Strain - Creamy & Citrusy Hybrid | BeyondBloom™" />
        <meta
          property="og:description"
          content="Zoap is a premium cannabis strain featuring a complex aroma with creamy, citrusy notes. Perfect for a balanced and enjoyable experience."
        />
        <meta property="og:image" content="/images/zoap.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/zoap" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Zoap Strain - Creamy & Citrusy Hybrid | BeyondBloom™" />
        <meta
          name="twitter:description"
          content="Zoap is a premium cannabis strain featuring a complex aroma with creamy, citrusy notes. Perfect for a balanced and enjoyable experience."
        />
        <meta name="twitter:image" content="/images/zoap.png" />
      </Helmet>
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Zoap;
